
import { Component, Watch } from 'vue-property-decorator'
import CommonPopup from '../../../components/CommonPopup.vue';

@Component({
    components: {CommonPopup}
})
export default class TermsPop3 extends CommonPopup{
  @Watch("opened")
  refresh(type: boolean) {
    this.isPullToRefreshEnabled(!type);
  } 
}
